import { TOKEN_LOCALSTORAGE_KEY } from "../const";

export default function accessToken() {
  const token = localStorage.getItem(TOKEN_LOCALSTORAGE_KEY);

  return token || "";
}
